type Win = {
  user_id: number;
  user_name: string;
  amount: number;
  gameDetails: { img: string };
};

export default function getCasinoRecentBigWinsMockData(tenantMachineName: string = 'vatan-game'): Win[] {
  const base = `/images/tenants/${tenantMachineName}/games`;

  return [
    {
      user_id: 1,
      user_name: 'FastWinX',
      amount: 656332,
      gameDetails: { img: `${base}/mines.jpg` },
    },
    {
      user_id: 2,
      user_name: 'SuperGamer',
      amount: 66332,
      gameDetails: { img: `${base}/coin-flip.jpg` },
    },
    {
      user_id: 3,
      user_name: 'SlotBoss777',
      amount: 405204,
      gameDetails: {
        img: 'https://media.ttfileserver.com/376/pragmatic/300x300/23002.png',
      },
    },
    {
      user_id: 4,
      user_name: 'CrashMaster',
      amount: 257891,
      gameDetails: { img: `${base}/crash.jpg` },
    },
    {
      user_id: 5,
      user_name: 'SpinWizard',
      amount: 20054,
      gameDetails: { img: `${base}/roulette.jpg` },
    },
    {
      user_id: 6,
      user_name: 'GoldenBetz',
      amount: 906545,
      gameDetails: {
        img: 'https://media.ttfileserver.com/394/galaxsys/300x300/62061.png',
      },
    },
    {
      user_id: 7,
      user_name: 'LuckyStrike88',
      amount: 52323,
      gameDetails: { img: `${base}/plinko.jpg` },
    },
    {
      user_id: 8,
      user_name: 'CrashKing',
      amount: 64267,
      gameDetails: { img: `${base}/limbo.jpg` },
    },
    {
      user_id: 9,
      user_name: 'DiceChampion',
      amount: 178400,
      gameDetails: { img: `${base}/dice.jpg` },
    },
    {
      user_id: 10,
      user_name: 'Tgyrplxwuma',
      amount: 52397,
      gameDetails: { img: `${base}/keno.jpg` },
    },
    {
      user_id: 11,
      user_name: 'HiLoHero',
      amount: 345120,
      gameDetails: { img: `${base}/hi-lo.jpg` },
    },
    {
      user_id: 12,
      user_name: 'ChipsAndGlory',
      amount: 32154,
      gameDetails: { img: `${base}/blackjack.jpg` },
    },
    {
      user_id: 13,
      user_name: 'WheelWonder',
      amount: 412300,
      gameDetails: { img: `${base}/wheel.jpg` },
    },
    {
      user_id: 14,
      user_name: 'VivaJackpot & ChipsAndGlory',
      amount: 340000,
      gameDetails: {
        img: 'https://media.ttfileserver.com/406/aviatrix/300x300/57500.png',
      },
    },
    {
      user_id: 15,
      user_name: 'RollinRich',
      amount: 20054,
      gameDetails: {
        img: 'https://media.ttfileserver.com/388/smartsoft/300x300/47141.png',
      },
    },
  ];
}
